const empirical = {
  namespaced:true,
  state: () => ({
    detail: {},
    feedVarietyList: [], // 品种
    varietyVisible: false,
    variety2Visible: false,
    tabKey: 0,
    paneType: '', // 绑定tabs 的key
    varietySelect: [], // 选中品种
    dateField: '', // 日期字段
    varietyDate: null, // 选中日期
    varietyType: '', // 当前选择鱼的类型
    stockingFish: [], // 放养的鱼的品种
    stockingCSFish: [], // 死鱼的品种
    aquaticLineFishStockingInfo: {}, // 鱼类放养基本信息
    aquaticLineFishStockingInfoDetails: [{stockingDate: null,details: []}], // 鱼类放养列表
    aquaticLineFishFeedInfos: [], // 用料信息
    aquaticLineFishProofingHarvestInfo: {}, // 打样基本信息
    aquaticLineFishProofingHarvestInfoDetails: [{proofingHarvestDate: null,details: []}], // 打样列表
    aquaticLineFishDieInfo: {}, // 死鱼信息
    aquaticLineFishDieInfoDetails: [{dieDate: null,details: []}], // 死鱼列表
    hasFish: true,
    currentFactory: '',
    sortRow: {},
    sortDetailVisible: false,
  }),
  mutations:{
    setState(state, payload) {
      for (let i in payload) {
        state[i] = payload[i]
      }
    },
  }
}

export default empirical